export default __webpack_public_path__ + "static/media/find-a-provider-icon-active.c356304d.svg";